import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';

/** Fournisseur d'identité d'une société (GET /user_providers, admin, lecture seule) : son nom (« Okta Webcentric ») */
export default class UserProviderModel extends AbstractApiModel {
  protected _path = '/user_providers/{?id}';

  @doc.string declare name: string;
}
